// ABOUTME: Gives its children a way to open the confirmation to cancel one Nylas-booked session
// ABOUTME: Only with a cancel-session link and a time; SessionChangeDialogs shows the prompt
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { ReactNode } from 'react';
import { CancelTarget } from './CancelTarget';
import { sessionChangeStore } from './SessionChangeStore';

interface Props {
  cancel: Maybe<CancelTarget>;
  // What the opening page refreshes once a change succeeds; nothing when the platform's shared
  // events refresh is enough.
  refresh: Maybe<() => void>;
  children: (open: Maybe<() => void>) => ReactNode;
}

const CancelCoachingSession = ({ cancel, refresh, children }: Props) => (
  <>
    {children(
      cancel.map((target) => () => {
        sessionChangeStore.openCancel(target, refresh);
      }),
    )}
  </>
);

export default observer(CancelCoachingSession);
